export default __webpack_public_path__ + "static/media/404.de515a35.svg";